import { getUserId } from "../helpers"

export const getUserContentSuggestions = (contentType:string): Promise<any> =>{
  return new Promise<any[]>((resolve)=>{
    const userID = getUserId()
    const url = process.env.REACT_APP_IBL_DM_URL + `/api/catalog/suggestions/${contentType}/user/?user_id=${userID}`
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    }).then((response)=>{
      response.json().then((data:any)=>{
        resolve(data)
      })
    }).catch((error)=>{
      resolve(null)
    })
  })

}